// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"50":"c8e439ca","61":"3e71f7aa","236":"380bdac7","516":"a52ca93d","578":"d01743a4","942":"00ce982a"}[chunkId] + ".css";
};